var React = require('react');

function ToolReact (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"className":"fill-foreground","cx":"12","cy":"12","r":"1.6","key":0}),React.createElement("g",{"className":"fill-none stroke-background","strokeWidth":"1","strokeMiterlimit":"10","key":1},[React.createElement("ellipse",{"transform":"matrix(0.5 -0.866 0.866 0.5 -4.3923 16.3923)","cx":"12","cy":"12","rx":"8.7","ry":"3.5","key":0}),React.createElement("ellipse",{"transform":"matrix(1.307792e-02 -0.9999 0.9999 1.307792e-02 -0.1559 23.842)","cx":"12","cy":"12","rx":"3.5","ry":"8.7","key":1}),React.createElement("ellipse",{"transform":"matrix(0.8688 -0.4951 0.4951 0.8688 -4.3674 7.5158)","cx":"12","cy":"12","rx":"3.5","ry":"8.7","key":2})])]);
}

ToolReact.defaultProps = {"version":"1.0","width":"48","height":"48","viewBox":"0 0 24 24"};

module.exports = ToolReact;

ToolReact.default = ToolReact;
